import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useEffect, useState } from 'react'

export const handleShowComponent = (show) => {
    return show ? 'contents' : 'none'
}

const ShowComponent = ({ children, show, kill }) => {
    const [firstRender, setFirstRender] = useState(show)

    useEffect(() => {
        if (show) {
            setFirstRender(true)
        }
    }, [show])

    return (
        <Grid id='teste' sx={{ display: handleShowComponent(show) }}>
            {(firstRender && !kill) && children}
        </Grid>
    )
}

export default ShowComponent
